// Library Methods
import { useQuery } from "@tanstack/react-query";
import { useAuth0 } from "@auth0/auth0-react";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { UserSettingsType } from "../types";
import { getUserSettings } from "../api";

export const useUserSettings = () => {
  const { isAuthenticated } = useAuth0();
  const { getToken } = useTokenAccess();

  return useQuery<UserSettingsType>({
    queryKey: ["user-settings"],
    queryFn: async () => {
      const token = await getToken();
      return getUserSettings(token);
    },
    // Settings belong to the logged in user
    enabled: isAuthenticated,
    refetchOnWindowFocus: false,
  });
};
